import React from "react";

import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { semanticBackgroundClasses } from "../../theme/semanticClasses";

type Props = {
  title?: string;
  className?: string;
  color?: string;
  subtitle?: string;
  subtitleValue?: string | number;
  children?: React.ReactNode;
  navigationLinks?: { link: string; label: string }[];
};

const MenuHeaderCategory = ({
  title,
  className = "",
  color = "primary",
  subtitle,
  subtitleValue,
  navigationLinks,
}: Props) => {
  const colorClasses =
    semanticBackgroundClasses[color] ?? semanticBackgroundClasses.primary;
  return (
    <div
      className={`min-h-[175px] w-full rounded-card px-9 pt-7 ${colorClasses} ${className}`}>
      <div className="flex w-full items-center justify-between">
        <h3 className="m-0 text-[1.35rem] font-semibold text-white">{title}</h3>
        {!!navigationLinks && (
          <div className="flex gap-2">
            {navigationLinks.map(({ link, label }, index: number) => (
              <Link key={index} to={link}>
                <button
                  type="button"
                  className="rounded-control bg-white px-3 py-2 font-medium text-slate-900 shadow-xs transition hover:bg-surface-hover">
                  <Typography className="text-inherit">{label}</Typography>
                </button>
              </Link>
            ))}
          </div>
        )}
      </div>
      {subtitle && subtitleValue && (
        <div className="flex flex-col pt-8 text-center text-white">
          <span className="text-base font-medium">{subtitle}</span>
          <span className="pt-1 text-2xl font-semibold">{subtitleValue}</span>
        </div>
      )}
      <div className="h-[100px]" />
    </div>
  );
};

export default MenuHeaderCategory;
